var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('div',[_c('v-select',{attrs:{"items":_vm.items},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})],1):_c('p',[_vm._v("Loading")])])}
var staticRenderFns = []

export { render, staticRenderFns }